var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 2L39.8797 7.748L49.6342 7.73L52.6297 17.012L60.5317 22.73L57.5002 32L60.5317 41.27L52.6297 46.988L49.6342 56.27L39.8797 56.252L32.0002 62L24.1207 56.252L14.3662 56.27L11.3707 46.988L3.46875 41.27L6.50025 32L3.46875 22.73L11.3707 17.012L14.3662 7.73L24.1207 7.748L32.0002 2Z",
    stroke: "#00629B",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 32L29 39.5L44 24.5",
    stroke: "#00629B",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckPrimary);
export default __webpack_public_path__ + "static/media/success-check-primary.9fd06ebd1de5e64ae0907261b74856e4.svg";
export { ForwardRef as ReactComponent };